import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const certificatesScreenModule = defineScreen({
  app: "coaching",
  screen_id: "certificates",
  path: "/certificates",
  heading: { text: "Certificates", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "deny",
    "company_admin": "deny",
    "participant": "deny",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "page.load" }
  ],
  recipe: "Page-1",
  data: { seedNeeds: ["readonly-walk-session"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/certificates.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default certificatesScreenModule;
